'use strict';

import vendorConsents from './vendor-consents.js';
import localStorageUtils from './localStorageUtils.js';
import logger from './logger.js';
import user from '../profile/user.js';

const permutive = window.permutive;
const CONSENT_STORAGE_KEY = 'consentData';  // Match the key from consent manager
const classNames = {
	targetingUpdateData: 'permutive-targeting-update-data',
};

const onConsentGranted = () => {
	logger.info('Permutive consent has been granted - data will be collected');
	permutive.consent({ 'opt_in': true, 'token': 'CONSENT_CAPTURED' });
};

const onConsentRefused = () => {
	logger.info('Permutive consent has not been granted - no data will be collected');
	permutive.consent({ 'opt_in': false });
};

const updateTargeting = () => {
	const updateData = $.findByBem(classNames.targetingUpdateData).attr('data-value');
	const carsData = JSON.parse(updateData);
	const postcode = user.getPostcode();

	// Remove null values
	Object.keys(carsData).forEach(key => {
		if (carsData[key] === null) {
			delete carsData[key];
		}
	});

	const permutiveDataModel = {
		cars: carsData,
		user: {
			known: window.permutiveUserKnown,
			postcode_district: postcode
		}
	};

	permutive.addon("web", {
		page: permutiveDataModel
	});
}

export default {
	init: function () {
		const storedConsent = localStorageUtils.getItem(CONSENT_STORAGE_KEY);
		if (!storedConsent) {
			logger.warning('Failed to initialise permutive: No consent data');
			return;
		}

		const hasPermutiveConsent = storedConsent.consentedVendors.includes(vendorConsents.vendorIds.permutive);
		if (hasPermutiveConsent) {
			onConsentGranted();
		} else {
			onConsentRefused();
		}
	},

	updateTargeting: updateTargeting
}